import React from 'react';
import { Box, Typography, Grid, Card, CardContent, Button, Chip, Stack } from '@mui/material';
import WeekendIcon from '@mui/icons-material/Weekend';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';

export const tips = [
  {
    title: 'Vacuum Regularly',
    description: 'Vacuum carpets, rugs, and upholstery at least once a week to keep dust and allergens at bay.',
  },
  {
    title: 'Dust Surfaces',
    description: 'Use a microfiber cloth to dust shelves, electronics, and decor items for a spotless look.',
  },
  {
    title: 'Spot Clean Spills',
    description: 'Blot spills on furniture and carpets immediately to prevent stains from setting.',
  },
  {
    title: 'Pro Tip: Freshen Upholstery',
    description: 'Sprinkle baking soda on sofas and chairs, let sit 15 minutes, then vacuum for odor removal.',
    pro: true,
  },
  {
    title: 'Clean Windows',
    description: 'Wipe windows and glass doors with a streak-free cleaner for a brighter living space.',
  },
  {
    title: 'Declutter Weekly',
    description: 'Remove unused items and organize remotes, magazines, and toys for a tidy room.',
  },{
    title: 'Electronics Dust-Shield',
    description: 'Use an anti-static microfiber cloth on TV screens and game consoles. Keeps screens clearer and prevents dust from being magnetized onto surfaces.',
  },
  {
    title: 'Leather & Faux-Leather Conditioning',
    description: 'After cleaning, apply a tiny dab of leather conditioner or olive oil on a soft cloth, buff in. Stops cracking and restores supple texture.',
  },
  {
    title: 'Rug-Revival Steam',
    description: 'Rent or buy a handheld carpet steamer for area rugs. Light steaming releases deeply embedded dirt and revives fibers without harsh detergents.',
  },
  {
    title: 'Under-Cushion Patrol',
    description: 'Pop off sofa cushions quarterly and vacuum underneath—crumbs and dust accumulate unseen and attract pests.',
  },
  {
    title: 'Vent & Radiator Detail',
    description: 'Vacuum radiator fins with a narrow crevice tool, then wipe with a damp microfiber to remove settled grime that hampers heat output.',
  },
  {
    title: 'Furniture-Leg Floor Guards',
    description: 'Stick clear felt pads under all furniture legs. Prevents micro-scratches on hardwood and makes moving pieces for cleaning far easier.',
  }
];

const LivingRoomTips = () => (
  <Box sx={{ mb: 6 }}>
    <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
      <WeekendIcon color="primary" sx={{ fontSize: 40 }} />
      <Typography variant="h4" fontWeight={700}>
        Living Room Cleaning Tips
      </Typography>
    </Stack>
    <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 4 }}>
      Make your living room inviting and fresh with these cleaning tips!
    </Typography>
    <Grid container spacing={3}>
      {tips.map((tip, idx) => (
        <Grid item xs={12} sm={6} md={4} key={idx}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', p: 1 }}>
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="h6" fontWeight={600} sx={{ flexGrow: 1 }}>
                  {tip.title}
                </Typography>
                {tip.pro && (
                  <Chip icon={<EmojiObjectsIcon />} label="Pro Tip" color="warning" size="small" />
                )}
              </Stack>
              <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
                {tip.description}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
      <Button variant="contained" color="primary" size="large">
        See all living room tips
      </Button>
    </Box>
  </Box>
);

export default LivingRoomTips; 